import { Component, OnInit, Input } from '@angular/core';
import { JwtAuthService } from '../../../shared/services/auth/jwt-auth.service';

@Component({
  selector: 'app-sidenav',
  templateUrl: './sidenav.template.html'
})
export class SidenavComponent implements OnInit{
  @Input('items') public menuItems: any[] = [];
  @Input('hasIconMenu') public hasIconTypeMenuItem: boolean;
  @Input('iconMenuTitle') public iconTypeMenuTitle: string;

  constructor(
    private jwtAuthService: JwtAuthService
  ) {}
  ngOnInit() {
    console.log('SidenavComponent.ngOnInit ');
    // this.removeElementFromObjectArray('LIBERACAO');
    console.log(this.jwtAuthService?.item$?.value?.roles);
    // if(this.jwtAuth.isRoleAuthorized(this.jwtAuth?.item$?.value, 'ROLE_ROOT') ){
    //   console.log('With Great Power Comes Great Responsibility!');
    // }else {
    //   this.removeElementFromObjectArray('LIBERACAO');
    //   this.removeElementFromObjectArray('ACCESS');
    // }
    console.log(this.menuItems);
  }

  getMenuItems(){
    
    if(this.jwtAuthService.isRoleAuthorized(this.jwtAuthService?.item$?.value, 'ROLE_ROOT')  ){
      //todos os Menus
      return this.menuItems;
    } 
   
    if (this.jwtAuthService.isRoleAuthorized(this.jwtAuthService?.item$?.value, 'ROLE_ADMIN_WRITE') || this.jwtAuthService.isRoleAuthorized(this.jwtAuthService?.itemRemoto$?.value, 'ROLE_ADMIN_WRITE')) {
      // não mostra a liberação p/ ROLE_ADMIN
      return this.menuItems.filter(value => value.name !== 'LIBERACAO');
    }
    if (this.jwtAuthService.isRoleAuthorized(this.jwtAuthService?.item$?.value, 'ROLE_ADMIN_READ') || this.jwtAuthService.isRoleAuthorized(this.jwtAuthService?.itemRemoto$?.value, 'ROLE_ADMIN_READ')) {
      // não mostra a liberação p/ ROLE_ADMIN  
      return this.menuItems.filter(value => value.name !== 'LIBERACAO' && value.name !== 'ACCESS');
    }
    // não mostra liberação e acesso para usuários normais.
    const restrictedItems = ['LIBERACAO', 'ACCESS', 'CADASTROS', 'FATURAMENTO', 'FINANCEIRO', 'MOVIMENTACAO', 'MARKETPLACE', 'RELATORIO'];
    const restrictedSubItems = ['BANNER', 'NOTIFICACAO', 'GERENCIADOR', 'ASSINA', 'IMPORTA'];
    return this.filterSubItems(this.menuItems.filter(value => !restrictedItems.includes(value.name)), restrictedSubItems);

  }

  filterSubItems(menuItems: any[], restrictedSubItems: string[]): any[] {
    return menuItems.map(item => {
      if (item.sub && item.sub.length > 0) {
        item.sub = item.sub.filter((subItem: { name: string }) => !restrictedSubItems.includes(subItem.name));
      }
      return item;
    });
  }

  removeElementFromObjectArray(key: string) {
    this.menuItems.forEach((value,index)=>{
        if(value.name === key) this.menuItems.splice(index,1);
    });
} 

  // Only for demo purpose
  addMenuItem() {
    this.menuItems.push({
      name: 'ITEM',
      type: 'dropDown',
      tooltip: 'Item',
      icon: 'done',
      state: 'material',
      sub: [
        {name: 'SUBITEM', state: 'cards'},
        {name: 'SUBITEM', state: 'buttons'}
      ]
    });
  }

 
}